import styled from 'styled-components';
import {CalendarIcon} from '../../atoms/Icons';
import TextButton from '../../atoms/TextButton';
import { SurfaceColor,DividerColor,Grey700,Green,ScoreColor } from '../../Colors';

const defaultStyle = {
	Wrapper : styled.div`
         & > h4 {
            color : ${Grey700};
        }
        & > ul {
			list-style: none;
			padding-left : 2rem;
		}
    `,
	ActivityHistory : styled.div`
        background-color : ${SurfaceColor};
        padding : 3rem;
        & > table {
            border-collapse: collapse;
            width : 100%;
        }
        & > table,th {
            border-bottom:1px ${DividerColor} solid;
        }
    `,
	Recipe : styled.div`
        padding : 1rem;
        display : flex;
        justify-content : flex-end;
        & > #link {
            margin-right: auto;
        }
    `,
	Score : styled.div`
        color : ${({pcnt})=>{
		return ScoreColor(pcnt);
	}};
    `,
	TextButton : styled(TextButton)`
        &:hover {
            background-color : transparent;
        }
        &:focus {
            background-color : transparent;
        }
    `,
	IconWrapper : styled.span`
        margin-right : 1rem;
        color : ${Green};
    `,
	CalendarIcon,
	NoActivity : styled.div`
        background-color : ${SurfaceColor};
        padding : 3rem;
        & > div{
            text-align : right;
        }
    `,
	LOD : styled.div`
        padding : 1rem;
        text-align : right;
    `,
};

const mobileStyle = {
	Wrapper : styled.div`
    & > h3 {
        color : ${Grey700};
        padding-left : 1rem;
    }
    & > ul {
        list-style: none;
        padding-left : 2rem;
    }
    `,
};

export default defaultStyle;
export {mobileStyle};
